export const useDefaultData = () => {

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormUser = {
        userPassword: '',
        userConfirmPassword: ''
    }
    
    return Object.freeze({
        defaultDataModal,
        defaultFormUser
    })
}